<span
  [ngbTooltip]="
    required ? contentWrapper?.textContent?.trim() + ' is required' : null
  "
>
  <span #contentWrapper><ng-content></ng-content></span>
  @if (required) {
    <span class="required fw-bold">*</span>
  }
</span>
